<template>
	<div class="remove">
		<i class="fas fa-trash-alt"></i>
		<span class="titulo"> {{ titulo }}</span>
		<span class="sub-titulo"> {{ subTitulo}}</span>
		<div class="btns">
			<div class="button descartar" @click="descartar">Cancelar</div>
			<div class="button remover" @click="remover">Remover</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ModalRemove',
	props: {
		titulo: { type: String, default: '' },
		subTitulo: { type: String, default: '' },
		id: String,
		item: String
	},
	methods: {
		descartar () {
			this.$emit('boxDescartar', this.id, this.item)
		},
		async remover () {
			console.log('fdsfdsfdsfds')
			this.$emit('boxDelete', this.id, this.item)
		}
	}
}
</script>

<style lang="scss" scoped>
	.remove {
		background-color: #FEFEFE;
		display:flex;
		flex-direction: column;
		padding:10px;
		border-radius:5px;
		width: 584px;
		position:fixed;
		left: 50%;
		top: 30%;
		margin-left: -292px;

		i {
			color:#F84545;
			font-size: 43px;
			margin-bottom: 18px;
		}

		.titulo {
			color:#052354;
			font-weight: 700;
			font-size: 20px;
			margin-bottom: 11px;
		}

		.sub-titulo {
			color:#8B94A7;
		}

		.nome {
			color:#EBECEF;
			border: 1px solid;
			border-radius: 5px;
			height: 40px;
			margin-bottom: 11px;

			input {
				background-color: #F8F9FB;
				color:#8B94A7;
				border: none;
				border-radius: 5px;
				width: 100%;
				height: 100%;
				padding: 10px;
				font: Condensed 16px Roboto;
			}
		}

		.descricao {
			color:#EBECEF;
			border: 1px solid;
			border-radius: 5px;
			height: 128px;
			margin-bottom: 16px;

			textarea {
				background-color: #F8F9FB;
				color:#8B94A7;
				border: none;
				border-radius: 5px;
				width: 100%;
				height: 100%;
				padding: 10px;
				font: Condensed 16px Roboto;
			}
		}

		.btns {
			display:flex;
			justify-content: flex-end;
			background-color: #F8F9FB;
			height: 100px;
			align-items: center;
			margin: -10px;
			margin-top:50px;

			.button {
				padding: 12px 20px;
				width: 136px;
				height: 47px;
				display: flex;
				justify-content: center;
				font-weight: 700;
				margin-right: 10px;
				cursor: pointer;

				&.descartar {
					background-color:#FFFFFF;
					border-radius:5px;
					border: 1px solid;
					border-color: #06162B;
					color:#06162B;
				}

				&.remover {
					background-color: #F84545;
					border-radius:5px;
					border: 1px solid;
					color:#FFFFFF;
				}
			}
		}
	}
</style>
